import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { EffectCreative } from 'swiper/modules';
import './signup-policy.css';
import { faLock, faFileSignature, faFileContract, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
 import { NavLink } from "react-router-dom";



const SignupPolicy = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
    const [activeTab, setActiveTab] = useState('Empower');
    const [openBioIndex, setOpenBioIndex] = useState(null);
      const [selectedMember, setSelectedMember] = useState(null);
        const [openIndex, setOpenIndex] = useState(null);
      const [directors, setDirectors] = useState([]);
        const [showAll, setShowAll] = useState(false);
       
  

  const closeBio = () => {
  setSelectedMember(null);
};  
 
  
const toggleBio = (index) => {
  setOpenBioIndex(prevIndex => (prevIndex === index ? null : index));
};

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
    const handleBioClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  
const navItems = [

  { title: 'आम्ही कोण आहोत?', path: '/leadership' },
   { title: 'बातम्या आणि ब्लॉग', path: '/news' },
  { title: 'संपर्क करा', path: '/contact' },
];

  return (
    <>
   
 

     {/* Header */}
            <header className="header">
                          <div className="nav-container">
                            <div className="logo">
                              <Link to="/">
                                <img src="web.png" alt="PIR Logo" />
                              </Link>
                            </div>
                        
                            {/* Desktop Nav */}
                            <nav className="nav-links">
                                                                          {navItems.map((item, index) => (
                                                                            <div key={index} className="nav-item">
                                                                              <NavLink
                                                                                to={item.path}
                                                                                className={({ isActive }) =>
                                                                                  isActive ? "nav-button active" : "nav-button"
                                                                                }
                                                                              >
                                                                                {item.title}
                                                                              </NavLink>
                                                                            </div>
                                                                          ))}
                                                                        </nav>
                        
                            {/* Search + Title */}
                            <div className="search-language" style={{ position: "relative" }}>
                              <div
                                style={{
                                  position: "absolute",
                                  top: "-19px",
                                  left: "16px",
                                  fontSize: "22px",
                                  color: "#FF6F00",
                                  fontFamily: "Mukta, sans-serif",
                                  whiteSpace: "nowrap",
                                  zIndex: 10,
                                  pointerEvents: "none",
                                }}
                              >
                                <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
                              </div>
                        
                              <div className="pir-search-wrapper">{/* Search Bar */}</div>
                            </div>
                        
                            {/* Hamburger Toggle */}
                            <button
                              className="mobile-toggle"
                              onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                            >
                              ☰
                            </button>
                          </div>
                        
                          {/* Mobile Menu */}
                          {isMobileMenuOpen && (
                            <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
                          {navItems.map((item, index) => (
                            <Link
                              key={index}
                              className="mobile-link"
                              to={item.path}
                              onClick={() => setMobileMenuOpen(false)}
                            >
                              {item.title}
                            </Link>
                          ))}
                        </div>
                          )}
                        </header>
       <div className="b">
  <h1>📝 नोंदणी धोरण (Registration / Signup Policy)</h1>

  <h2>1. लागू क्षेत्र</h2>
  <p>
    हे धोरण lokadhikar.in वरील नोंदणी, खाते निर्मिती, सदस्य/कार्यकर्ता/स्वयंसेवक साइनअप, कार्यक्रम/आंदोलन नोंदणी,
    न्यूजलेटर सबस्क्रिप्शन इत्यादींवर लागू आहे.
  </p>

  <h2>2. पात्रता (Eligibility)</h2>
  <ul>
    <li>नोंदणीसाठी सामान्यतः १८ वर्षांपेक्षा जास्त वय आवश्यक.</li>
    <li>जर आपण कोणत्याही संस्था/कंपनीच्या वतीने नोंदणी करत असाल, तर आपण त्या संस्थेचे अधिकृत प्रतिनिधी असल्याचे आपण पुष्टी करता.</li>
    <li>खोटी माहिती, भ्रामक माहिती, किंवा इतरांच्या नावाने नोंदणी करणे मनाई आहे.</li>
  </ul>

  <h2>3. आवश्यक माहिती</h2>
  <p>
    नोंदणी करताना आम्ही नाव, ईमेल, मोबाईल, पत्ता, वय, व्यावसायिक माहिती, फोटो, सोशल मीडिया लिंक, आणि (लागू असल्यास)
    ओळख पडताळणी कागदपत्रे मागू शकतो. आपण देत असलेली माहिती बरोबर, संपूर्ण आणि अद्ययावत ठेवणे आवश्यक आहे.
  </p>

  <h2>4. खात्याची सुरक्षितता</h2>
  <p>
    आपल्या पासवर्ड/OTP/लॉगिन क्रेडेन्शियलची गुप्तता राखणे ही तुमची जबाबदारी आहे. कोणत्याही अनधिकृत वापराची शंका आल्यास
    त्वरित आम्हाला कळवा.
  </p>

  <h2>5. संवाद (Communications)</h2>
  <ul>
    <li>
      नोंदणीद्वारे आपण आम्हाला ईमेल/एसएमएस/व्हॉट्सअॅप इत्यादी मार्गांनी कार्यक्रम, अद्यतने, कायदेशीर माहिती, मोहिमा यासंबंधी
      संदेश पाठवण्याची परवानगी देता (consent).
    </li>
    <li>
      तुम्ही कोणत्याही वेळी unsubscribe / optout करू शकता (अटी: काही कायदेशीर/सेवा संबंधित संदेश अनिवार्य राहू शकतात).
    </li>
  </ul>

  <h2>6. आचारसंहिता (Code of Conduct)</h2>
  <ul>
    <li>धमकी, द्वेष, बदनामी, अश्लील/बेकायदेशीर/कॉपीराइट भंग करणारे कंटेंट पोस्ट करणे मनाई आहे.</li>
    <li>वेबसाइटचा वापर स्पॅम, फसवणूक, डेटा स्क्रॅपिंग, हॅकिंग किंवा कुठल्याही बेकायदेशीर उद्देशासाठी करू नये.</li>
    <li>
      संघटनेच्या प्रतिमेला बाधा आणणारी, कायदेशीर जोखीम निर्माण करणारी कोणतीही कृती आढळल्यास खाते निलंबित/रद्द केले जाऊ शकते.
    </li>
  </ul>

  <h2>7. सामग्रीचे स्वामित्व व परवाना (User Content & License)</h2>
  <p>
    आपण वेबसाइटवर अपलोड केलेल्या कोणत्याही मजकूर, फोटो, व्हिडिओ, कात्रणे इत्यादींवर (तुमचे हक्क राहतील) — मात्र,
    संघटना त्या सामग्रीचा संघटनेच्या ध्येय, जनजागृती आणि अहवाल/दस्तावेजीकरणासाठी वापर करण्यास आपण nonexclusive,
    royalty-free, worldwide license देता (आवश्यक असल्यास ही ओळ ठेवावी/काढावी).
  </p>

  <h2>8. निलंबन/समाप्ती (Suspension / Termination)</h2>
  <ul>
    <li>
      नियमांचे उल्लंघन, खोटी माहिती, बेकायदेशीर कृती, सुरक्षा धोका, किंवा संघटनेच्या धोरणांचा भंग झाल्यास खाते तात्पुरते/कायमस्वरूपी
      बंद केले जाऊ शकते.
    </li>
    <li>
      खाते बंद झाल्यानंतरही, कायद्याने परवानगी दिल्याप्रमाणे आपल्या डेटाबाबत आम्ही आवश्यक नोंदी जतन ठेवू शकतो.
    </li>
  </ul>

  <h2>9. डेटा विलोपन व अधिकार</h2>
  <p>
    खाते बंद/माहिती विलोपन बाबतचे तुमचे अधिकार DPDP Act, 2023 नुसार असतील (उदा. correction, erasure, grievance
    redressal, withdrawal of consent, right to nominate). कृपया आमच्या गोपनीयता धोरणाकडे पहा.
  </p>

  <h2>10. दायित्व मर्यादा (Limitation of Liability)</h2>
  <p>
    वेबसाइटवरील माहिती “as-is” तत्त्वावर दिली जाते. तृतीयपक्ष सेवांमुळे उद्भवणाऱ्या त्रुटी/प्रतीक्षा/उपलब्धता यांसाठी आम्ही
    थेट जबाबदार नसू; मात्र वाजवी काळजी घेतो.
  </p>

  <h2>11. लागू कायदा व वाद निवाडा</h2>
  <p>
    या धोरणांवर भारतीय कायदा लागू राहील. वाद उद्भवल्यास महाराष्ट्र राज्यातील (उदा. पुणे/मुंबई) न्यायालयांना jurisdiction
    अधिकार राहील.
  </p>

  <h2>12. बदल (Changes)</h2>
  <p>
    नोंदणी धोरण वेळोवेळी बदलले जाऊ शकते. महत्त्वपूर्ण बदल झाल्यास आम्ही तुम्हाला कळवू.
  </p>
</div>

        
    
       
 <footer className="pir-footer">
    <div className="footer-container">
      {/* Logo on the left */}
      <div className="footer-left">
        <img src="/web.png" alt="Logo" className="footer-logo-vertical" />
      </div>

      {/* Center: Two columns of links */}
      <div className="footer-center">
        <div className="footer-links-columns">
          <ul className="footer-links">
            <li>
              <a href="/privacypolicy">
                <FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण <span>(Privacy Policy)</span>
              </a>
            </li>
            <li>
              <a href="/signuppolicy">
                <FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण <span>(Signup Policy)</span>
              </a>
            </li>
          </ul>
          <ul className="footer-links">
            <li>
              <a href="/termsuse">
                <FontAwesomeIcon icon={faFileContract} /> वापर अटी <span>(Terms of Use)</span>
              </a>
            </li>
            <li>
              <a href="/disclaimer">
                <FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती <span>(Disclaimer)</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Right: Social links */}
      <div className="footer-right">
      <div className="footer-social">
                            <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                            <a href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                           <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                            <a href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg=" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                          </div>
      </div>
      
      
    </div>

    

    {/* Right side fixed icons */}


    {/* Bottom text */}
  <div className="footer-bottom">
    <p className="marathi-text">
      © २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span>
    </p>
  </div>

  </footer>
<ul className="right-side-icons">
    <li>
          <a href="/" className="icon-link pulse-glow" title="Home">
            <FontAwesomeIcon icon={faHome} />
          </a>
        </li>
        <li>
         <a href="tel:+917887779899" className="icon pulse-glow" title="Call Us">
            <FontAwesomeIcon icon={faPhone} />
          </a>
        </li>
       
      </ul>


    </>
  );
};

export default SignupPolicy;
